<template>
  <div id="footer" class="acea-row row-middle">
    <div
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
      @click="go(item.url)"
    >
      <div
        class="iconfont"
        :class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"
      ></div>
      <div>{{ item.name }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: [
        {
          name: "首页",
          icon1: "icon-shouye-xianxing",
          icon2: "icon-shouye",
          url: "/"
        },
        {
          name: "分类",
          icon1: "icon-yingyongchengxu-xianxing",
          icon2: "icon-yingyongchengxu",
          url: "/category"
        },

        {
          name: "我的",
          icon1: "icon-yonghu-xianxing",
          icon2: "icon-yonghu",
          url: "/user"
        }
        // {
        //   name: "创业商城",
        //   icon1: "icon-ziyuan-xianxing",
        //   icon2: "icon-ziyuan",
        //   url: "https://chuangye.aijiutang.com"
        // }
      ]
    };
  },
  methods: {
    go(url) {
      if (url.indexOf("http") >= 0) {
        let shareUid = this.$store.state.app.share_uid || 0;
        location.href = url + (shareUid ? "?share_uid=" + shareUid : "");
      } else {
        this.$router.push(url);
      }
    }
  }
};
</script>
